/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { max } from 'd3-array'
import groupBy from 'lodash/groupBy'
import sumBy from 'lodash/sumBy'
import CalculateHitLocation from '../../Utilities/CalculateHitLocation'

import Color from '../../Utilities/Colors/ColorMap'
import BoxLegend from '../../Legend/BoxLegend'
import Tooltip from '../../Tooltip/Tooltip'

export default function Boxes({ settings, chartOptions = {} }) {
    // Remove null spray
    let sprayData = settings.data

    // Set data to property in data set
    if (chartOptions.linkedDataProperty) {
        sprayData = settings.data[chartOptions.linkedDataProperty]
    }

    if (!chartOptions.isGrouped) {
        sprayData.map((d) => {
            d.xyGroup = `${Number(d.x)}${Number(d.y)}`
        })

        const groupData = groupBy(sprayData, (d) => d.xyGroup)

        sprayData = []
        for (const group in groupData) {
            const g = groupData[group]

            sprayData.push({
                value: Number(
                    _.sumBy(g, (d) => Number(d[chartOptions.sumColumn]))
                ),
                n: g.length,
                x: g[0].x,
                y: g[0].y,
            })
        }
    }

    const colorBox = scaleLinear()
        .domain(chartOptions.domain || [-5, 0, 5])
        .range(['#3661AD', '#ffffff', '#D82129'])
    const maxN = max(sprayData, (d) => Number(d.n))

    const size = scaleLinear()
        .domain([1, maxN])
        .range([settings.vizWidth * 0.006, settings.vizWidth * 0.022])

    function handleMouseOver(event, tip) {
        Tooltip(event, settings, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings)
    }

    function calculateX(coords, d) {
        let { x } = CalculateHitLocation(
            coords,
            settings.vizWidth,
            settings.vizHeight
        )
        const w = size(Number(d.n)) / 2
        x += size(Number(maxN)) / 2 - w
        return x
    }

    function calculateY(coords, d) {
        let { y } = CalculateHitLocation(
            coords,
            settings.vizWidth,
            settings.vizHeight
        )
        const w = size(Number(d.n)) / 2
        y += size(Number(maxN)) / 2 - w
        return y
    }

    return (
        <>
            <g id="sprayRectanglesChart">
                {sprayData.map((d, i) => {
                    const coords = { x: d.x, y: d.y }
                    return (
                        <>
                            {chartOptions.hideOuterRectangle ? null : (
                                <rect
                                    id={`rectOuter_${d.id || i}`}
                                    key={`outer_${i}`}
                                    x={
                                        CalculateHitLocation(
                                            coords,
                                            settings.vizWidth,
                                            settings.vizHeight
                                        ).x
                                    }
                                    y={
                                        CalculateHitLocation(
                                            coords,
                                            settings.vizWidth,
                                            settings.vizHeight
                                        ).y
                                    }
                                    width={settings.vizWidth * 0.022}
                                    height={settings.vizWidth * 0.022}
                                    fill={
                                        chartOptions.backgroundOuterFill ||
                                        'none'
                                    }
                                    opacity={chartOptions.outerOpacity || 1}
                                    stroke={
                                        chartOptions.outerStrokeColor ||
                                        '#f5f5f5'
                                    }
                                    style={{ cursor: 'pointer' }}
                                />
                            )}
                            <rect
                                id={`rectInner_${d.id || i}`}
                                key={`inner_${i}`}
                                x={calculateX(coords, d)}
                                y={calculateY(coords, d)}
                                width={size(d.n)}
                                height={size(d.n)}
                                fill={
                                    chartOptions.innerBackgroundFill ||
                                    colorBox(d.value)
                                }
                                opacity={chartOptions.innerOpacity || 1}
                                stroke={chartOptions.innerStrokeColor || '#000'}
                                strokeWidth={
                                    chartOptions.innerStrokeWidth || 0.5
                                }
                                style={{ cursor: 'pointer' }}
                                onMouseOver={(event) => {
                                    const html = d.tooltip
                                    if (html) {
                                        handleMouseOver(event, html)
                                    }
                                }}
                                onMouseOut={(event) => {
                                    handleMouseOut(event, d)
                                }}
                                onClick={() => {
                                    if (d.videoUrl) {
                                        window.open(d.videoUrl)
                                    }
                                }}
                            />
                        </>
                    )
                })}
            </g>
            {chartOptions.legend ? (
                <BoxLegend
                    settings={settings}
                    color={colorBox}
                    size={size}
                    maxCount={maxN}
                    chartOptions={chartOptions}
                />
            ) : null}
        </>
    )
}
